<template>
  <div id="componentFormPreview" class="card">
    <DataTable
      :value="admins"
      class="p-datatable"
      sortField="name" 
      :sortOrder="1"
      :paginator="true"
      :lazy="true"
      :rows="pageSize"
      :totalRecords="totalItemsCount"
      @page="onPage($event)"
      @sort="onSort($event)"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[10, 25, 50]"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      dataKey="id"
      :rowHover="true"
      :filters="filters"
      selectionMode="single"
      removableSort
      :loading="loading"
    >
      <template #header>
        <div class="table-header">
          <h5>Admins</h5>
          <Button
            label="New Admin"
            icon="pi pi-plus"
            class="p-button-secondary p-mr-2"
            @click="openAdminDialog()"
          />
        </div>
      </template>
      <template #empty> No User found. </template>
      <Column
        field="name"
        header="Name"
        sortable
        filterMatchMode="contains"
        class="p-col"
      >
        <template #filter>
          <InputText
            type="text"
            v-model="filters['name']"
            class="p-column-filter"
            placeholder="Search by Name"
            v-on:input="filterSearch('name')"
          />
        </template>
      </Column>
      <Column
        field="email"
        header="Email"
        sortable
        filterMatchMode="contains"
        class="p-col"
      >
        <template #filter>
          <InputText
            type="text"
            v-model="filters['email']"
            class="p-column-filter"
            placeholder="Search by Email"
            v-on:input="filterSearch('email')"
          />
        </template>
      </Column>

      <Column header="Actions" class="p-col">
        <template #body="slotProps">
          <Button
            icon="pi pi-trash"
            class="p-button-rounded p-button-danger p-mr-1"
            @click="deleteAdminConfirmation(slotProps.data)"
            v-tooltip.bottom="'Remove Admin'"
            
          />
        </template>
      </Column>
    </DataTable>
    <Dialog
      :visible.sync="newAdminDialog"
      header="Add New Admin"
      :modal="true"
      :contentStyle="{ overflow: 'visible' }"
      :style="{ width: '50vw' }"
    >
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12">
          <label for="Users"
            >Name<span class="p-invalid">*</span
            ></label
          >
          <AutoComplete
            v-model="userDetails.admins"
            :suggestions="filteredUsers"
            @complete="searchUsers($event)"
            field="name"
            required="true"
            :class="{ 'p-invalid': !userDetails.admins }"
          >
            <template #item="slotProps">
              <div>{{ slotProps.item.name }}</div>
              <div>{{ slotProps.item.email }}</div>
            </template>
          </AutoComplete>
          <span
              :class="{ 'p-invalid': !userDetails.admins }"
              v-if="!userDetails.admins"
              class="error-message"
              >User Name Required</span
            >
        </div>
      </div>
      <template #footer>
        <Button
          label="Save Admin"
          icon="pi pi-check"
          class="p-button-text"
          @click="saveAdmin()"
        />
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-text"
          @click="closeDialog()"
        />
      </template>
    </Dialog>
    <Dialog
      v-if="deleteAdmin"
      :visible.sync="deleteAdmin"
      header="Confirmation"
      :modal="true"
      :style="{ width: '30vw' }"
    >
      <div class="p-fluid p-grid">
        <div class="confirmation-content">
          
          <span>{{ dialogContent }}</span>
        </div>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="closeDialog()"
          class="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          @click="removeAdmin()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>
<script>
import _ from "lodash";
export default {
  data() {
    return {
      userDetails: {},
      filteredUsers: null,
      newAdminDialog: false,
      user_error: false,
      admins: [],
      pageSize: 10,
      totalItemsCount: null,
      filters: {},
      selectedPageSize: null,
      selectedPageNo: null,
      deleteAdmin: false,
      dialogContent: null,
      selectedAdmin: null,
      loading: false,
    };
  },
  created() {
    let input = {
      startPageNo: 1,
      recordsPerPage: this.pageSize,
      SortOrder: {
        columnName: "name",
        direction: 0,
      },
    };
    this.getAdmins(input);
  },
  methods: {
    searchUsers(event) {
      let that = this;
      if (!event.query.trim().length) {
        return;
      } else {
        this.$store
          .dispatch("application/getUsers", event.query)
          .then(() => {
            that.filteredUsers = that.$store.getters["application/getUsers"];

            that.admins.forEach((a) => {
              _.remove(that.filteredUsers, function(e) {
                if (a.userId == a.userId) {
                  return e.userId === a.userId;
                }
              });
            });
          })
          .catch((error) => {
            this.$toast.add({
              severity: "error",
              summary: "Error while searching users",
              detail: error.response.data,
              life: 3000,
            });
          });
      }
    },
    openAdminDialog() {
      this.userDetails = {};
      this.newAdminDialog = true;
    },
    closeDialog() {
      this.newAdminDialog = false;
      this.deleteAdmin = false;
    },
    validateFrom() {
      let app = this.userDetails.admins;
      if (!_.includes(app, "") && app !== undefined) {
        this.user_error = true;
      } else {
        this.user_error = false;
      }
    },
    saveAdmin() {
      let that = this;
      that.newAdminDialog = false;
      that.validateFrom();
      that.submitted = true;
      let input = that.userDetails.admins;
      if (this.user_error) {
         that.loading = true;
        that.$store
          .dispatch("settings/saveAdmin", input)
          .then(() => {
            //that.blockedDocument = false;
            that.loading = false;
            this.$toast.add({
              severity: "success",
              summary: "Admin saved successfully..",
              life: 3000,
            });
            this.getCurrentPageAdmins();
          })
          .catch((error) => {
            this.$toast.add({
              severity: "error",
              summary: "Error while saving Admin",
              detail: error.response.data,
              life: 3000,
            });
            that.newAdminDialog = false;
            that.loading = false;
          });
      }
    },
    getAdmins(input) {
      let that = this;
      this.loading = true;
      //this.blockedDocument = true;
      this.$store
        .dispatch("settings/getAdmins", input)
        .then((response) => {
          let result = that.$store.getters["settings/getAdmins"];
          that.admins = result.pageResult;
          that.totalItemsCount = result.totalRecords;
          //that.pageSize = that.applications.pageNo;
          console.log(response);
          let loggedUser = that.$store.getters["login/getUser"];
          that.hasAdminRights = loggedUser.hasAdminRights;
          // that.blockedDocument = false;
          that.loading = false;
          that.closeDialog();
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "Error while fetching admins",
            detail: error,
            life: 3000,
          });
          // that.blockedDocument = false;
        });
    },
    filterSearch(ctrl) {
      // console.log(ctrl);
      setTimeout(() => this.onPage(ctrl), 1000);
    },
    onSort(event) {
      setTimeout(() => this.onPage(event), 1000);
    },
    onPage(event) {
      this.loading = true;
      // console.log(event);
      let input = {
        startPageNo: event.page ? event.page + 1 : 1,
        recordsPerPage: event.rows ? event.rows : this.pageSize,
        filters: this.filters
          ? {
              name: this.filters.name == undefined ? null : this.filters.name,
              email:this.filters.email == undefined ? null : this.filters.email,
            } : null,
        SortOrder: {
          columnName: event.sortField ? event.sortField : "name",
          direction: event.sortOrder ? (event.sortOrder == 1 ? 0 : 1) : 1,
        },
      };
      this.selectedPageNo = input.startPageNo ? input.startPageNo : 1;
      this.selectedPageSize = input.recordsPerPage
        ? input.recordsPerPage
        : this.pageSize;

      this.getAdmins(input);
    },
    deleteAdminConfirmation(data){
      this.deleteAdmin = true;
      this.dialogContent = 'Are you sure, you want to remove ' + data.name + ' ?'
      this.selectedAdmin = data;
    },
    removeAdmin() {
      let that = this;
      let input = that.selectedAdmin;
      if (input) {
        that.$store
          .dispatch("settings/removeAdmin", input)
          .then(() => {
            that.newAdminDialog = false;
            //that.blockedDocument = false;
            this.$toast.add({
              severity: "success",
              summary: "Admin removed successfully..",
              life: 3000,
            });
            this.deleteAdmin = false;
            this.selectedAdmin = {};
            this.getCurrentPageAdmins();
          })
          .catch((error) => {
            this.$toast.add({
              severity: "error",
              summary: "Error while saving Admin",
              detail: error.response.data,
              life: 3000,
            });
            // that.blockedDocument = false;
          });
      }
    },
    getCurrentPageAdmins() {
      let currentReq = {
        startPageNo: this.selectedPageNo ? this.selectedPageNo : 1,
        recordsPerPage: this.selectedPageSize
          ? this.selectedPageSize
          : this.pageSize,
        filters: this.filters
          ? {
              title: this.filters.name == undefined ? null : this.filters.name,
              description:
                this.filters.email == undefined ? null : this.filters.email,
            }
          : null,
          SortOrder: {
          columnName: "name",
          direction: 0,
        },
      };
      this.getAdmins(currentReq);
    },
  },
};
</script>

